import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Hook para aplicar cores dinâmicas do tema
 * Carrega as cores do backend e aplica como CSS custom properties
 */
const useTheme = () => {
  const [theme, setTheme] = useState({
    primary_color: "#FE2C55",
    secondary_color: "#25F4EE",
    background_color: "#FFFFFF",
    text_color: "#0F0F0F"
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const controller = new AbortController();
    const fetchTheme = async () => {
      try {
        const response = await axios.get(`${API}/settings/theme`, {
          signal: controller.signal,
          timeout: 3000
        });
        const newTheme = response.data;
        setTheme(newTheme);
        
        // Apply CSS custom properties to root element
        const root = document.documentElement;
        root.style.setProperty('--color-primary', newTheme.primary_color || "#FE2C55");
        root.style.setProperty('--color-secondary', newTheme.secondary_color || "#25F4EE");
        root.style.setProperty('--color-background', newTheme.background_color || "#FFFFFF");
        root.style.setProperty('--color-text', newTheme.text_color || "#0F0F0F");
        
        // Generate hover and transparency variants
        root.style.setProperty('--color-primary-hover', adjustBrightness(newTheme.primary_color, 20));
        root.style.setProperty('--color-primary-10', hexToRgba(newTheme.primary_color, 0.1));
        root.style.setProperty('--color-primary-20', hexToRgba(newTheme.primary_color, 0.2));
        
      } catch (error) {
        // Silently fail - use defaults
      } finally {
        setLoading(false);
      }
    };

    fetchTheme();
    return () => controller.abort();
  }, []);

  return { theme, loading };
};

/**
 * Adjust brightness of a hex color
 */
function adjustBrightness(hex, percent) {
  if (!hex) return "#FE2C55";
  
  let r = parseInt(hex.slice(1, 3), 16);
  let g = parseInt(hex.slice(3, 5), 16);
  let b = parseInt(hex.slice(5, 7), 16);
  
  r = Math.min(255, Math.floor(r * (100 + percent) / 100));
  g = Math.min(255, Math.floor(g * (100 + percent) / 100));
  b = Math.min(255, Math.floor(b * (100 + percent) / 100));
  
  return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`;
}

/**
 * Convert hex to rgba
 */
function hexToRgba(hex, alpha) {
  if (!hex) return "rgba(20, 69, 61, 0.1)";
  
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  
  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

export default useTheme;
